import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const COMIC_STRIP = "https://customer-assets.emergentagent.com/job_23b5f19d-1a39-4e03-91cd-806fad7065f2/artifacts/cb4g16hh_70103C01-061A-4E7B-9D6F-987C8EDDE164.png";
const BEAST_SCENE = "https://customer-assets.emergentagent.com/job_23b5f19d-1a39-4e03-91cd-806fad7065f2/artifacts/bbglzk6j_12591FFB-336D-48CD-A693-DF82C4F4324D.png";

export const About = () => {
  return (
    <div>
      {/* Comic Strip Header */}
      <section style={{ background: '#000', borderBottom: '4px solid #FFD700' }}>
        <img
          src={COMIC_STRIP}
          alt="The origin story of Captain H"
          data-testid="about-comic-strip"
          style={{ width: '100%', height: 'auto', display: 'block' }}
        />
      </section>

      {/* Origin Story */}
      <section style={{ padding: '5rem 1.5rem', background: '#fff', borderBottom: '4px solid #000' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <h1 className="heading-1" style={{ textAlign: 'center', marginBottom: '2rem', color: '#000' }}>The Origin of Captain H</h1>

          {/* Chapter 1 */}
          <div style={{ marginBottom: '3rem' }}>
            <h2 style={{ fontFamily: "'Bangers', cursive", fontSize: '1.75rem', color: '#6A0DAD', letterSpacing: '0.03em', marginBottom: '1rem' }}>In the Beginning...</h2>
            <p style={{ color: '#333', lineHeight: 1.8, fontSize: '1.1rem', fontWeight: 500 }}>
              Restaurants thrived on hard work. Family-owned kitchens... late nights... early mornings... Every dollar earned meant something.
            </p>
            <p style={{ color: '#333', lineHeight: 1.8, fontSize: '1.1rem', fontWeight: 500, marginTop: '1rem' }}>
              But then... <em>it</em> showed up.
            </p>
          </div>

          {/* Beast Scene Image */}
          <div style={{ marginBottom: '3rem', border: '4px solid #000', borderRadius: '12px', overflow: 'hidden', boxShadow: '8px 8px 0px 0px #000' }}>
            <img src={BEAST_SCENE} alt="The Commission Beast attacks restaurants" style={{ width: '100%', height: 'auto', display: 'block' }} />
          </div>

          {/* Chapter 2 */}
          <div style={{ marginBottom: '3rem' }}>
            <h2 style={{ fontFamily: "'Bangers', cursive", fontSize: '1.75rem', color: '#FF3B30', letterSpacing: '0.03em', marginBottom: '1rem' }}>The Commission Beast</h2>
            <p style={{ color: '#333', lineHeight: 1.8, fontSize: '1.1rem', fontWeight: 500 }}>
              A massive, shadowy creature crept into the industry quietly. At first, it offered "help." More orders. More visibility.
            </p>
            <p style={{ color: '#333', lineHeight: 1.8, fontSize: '1.1rem', fontWeight: 500, marginTop: '1rem' }}>
              But with every order... it took a bite. 10%... 20%... sometimes more.
            </p>
            <div className="comic-card" style={{ marginTop: '1.5rem', borderColor: '#FF3B30', boxShadow: '6px 6px 0px 0px #FF3B30' }}>
              <p style={{ fontWeight: 700, color: '#FF3B30', fontSize: '1rem', marginBottom: '0.75rem' }}>Chains wrapped around restaurant owners:</p>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
                {['Commission Fees', 'Hidden Charges', 'Markups', 'Extra Costs'].map((item, i) => (
                  <div key={i} style={{ padding: '0.5rem 1rem', background: '#FEE2E2', border: '2px solid #FF3B30', borderRadius: '4px', fontWeight: 800, textTransform: 'uppercase', fontSize: '0.85rem', textAlign: 'center' }}>
                    {item}
                  </div>
                ))}
              </div>
              <p style={{ color: '#333', fontWeight: 600, marginTop: '1rem' }}>
                Profits disappeared. Margins shrank. The little guy... was getting eaten alive.
              </p>
            </div>
          </div>

          {/* Chapter 3 */}
          <div style={{ marginBottom: '3rem' }}>
            <h2 style={{ fontFamily: "'Bangers', cursive", fontSize: '1.75rem', color: '#6A0DAD', letterSpacing: '0.03em', marginBottom: '1rem' }}>The Breaking Point</h2>
            <p style={{ color: '#333', lineHeight: 1.8, fontSize: '1.1rem', fontWeight: 500 }}>
              One night... a small restaurant owner looked at their numbers: Busy dining room. Orders flying in. But... no money left.
            </p>
            <p style={{ color: '#333', lineHeight: 1.8, fontSize: '1.1rem', fontWeight: 500, marginTop: '1rem' }}>
              That's when it happened. From the frustration... from the unfairness... from the fight to survive... something awakened.
            </p>
          </div>

          {/* Chapter 4 - The Rise */}
          <div style={{ marginBottom: '3rem', padding: '2.5rem', background: '#FFD700', border: '4px solid #000', borderRadius: '12px', boxShadow: '8px 8px 0px 0px #000' }}>
            <h2 style={{ fontFamily: "'Bangers', cursive", fontSize: '2.25rem', color: '#000', letterSpacing: '0.03em', marginBottom: '1rem', textAlign: 'center' }}>The Rise of Captain H</h2>
            <p style={{ color: '#333', lineHeight: 1.8, fontSize: '1.1rem', fontWeight: 600, textAlign: 'center' }}>
              A surge of energy. A symbol appeared. The "H."
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', marginTop: '1.5rem', flexWrap: 'wrap' }}>
              {[
                { letter: 'H', meaning: 'Hustle' },
                { letter: 'H', meaning: 'Honor' },
                { letter: 'H', meaning: 'Hard-earned money' },
              ].map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Bangers', cursive", fontSize: '1.5rem', color: '#FFD700' }}>{item.letter}</div>
                  <span style={{ fontWeight: 800, fontSize: '1.1rem' }}>{item.meaning}</span>
                </div>
              ))}
            </div>
            <p style={{ color: '#333', lineHeight: 1.8, fontSize: '1.1rem', fontWeight: 600, textAlign: 'center', marginTop: '1.5rem' }}>
              Captain H was born. Stronger than fees. Faster than middlemen. Built to protect profits.
            </p>
          </div>

          {/* Chapter 5 */}
          <div style={{ marginBottom: '3rem' }}>
            <h2 style={{ fontFamily: "'Bangers', cursive", fontSize: '1.75rem', color: '#000', letterSpacing: '0.03em', marginBottom: '1rem' }}>The Fight Begins</h2>
            <p style={{ color: '#333', lineHeight: 1.8, fontSize: '1.1rem', fontWeight: 500 }}>
              Captain H took on the beast head-on. Every punch shattered commission fees, hidden charges, and third-party control. Chains broke. Margins returned. Restaurants took back control.
            </p>
          </div>

          {/* The Mission */}
          <div style={{ padding: '2.5rem', background: '#6A0DAD', border: '4px solid #000', borderRadius: '12px', boxShadow: '8px 8px 0px 0px #000' }}>
            <h2 style={{ fontFamily: "'Bangers', cursive", fontSize: '2.25rem', color: '#FFD700', letterSpacing: '0.03em', marginBottom: '1rem', textAlign: 'center' }}>The Mission</h2>
            <p style={{ color: 'rgba(255,255,255,0.9)', lineHeight: 1.8, fontSize: '1.1rem', fontWeight: 500, textAlign: 'center', marginBottom: '1.5rem' }}>
              Captain H isn't just a hero. He's a system. A weapon. A movement. Powered by HungrMates, he gives restaurant owners:
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap' }}>
              {['Direct Ordering', 'Full Control', 'Real Profits'].map((item, i) => (
                <div key={i} style={{ padding: '0.75rem 1.5rem', background: '#FFD700', border: '3px solid #000', borderRadius: '4px', fontWeight: 800, textTransform: 'uppercase', boxShadow: '3px 3px 0px 0px #000' }}>
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Taglines */}
      <section className="halftone-bg" style={{ padding: '4rem 1.5rem', background: '#FFF9DB', borderBottom: '4px solid #000', position: 'relative' }}>
        <div className="container" style={{ maxWidth: '800px', position: 'relative', zIndex: 1, textAlign: 'center' }}>
          <h2 className="heading-2" style={{ marginBottom: '2rem', color: '#000' }}>Our Battle Cries</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1rem' }}>
            {[
              'Take back your profits.',
              'Defeat the Commission Beast.',
              'Powered by Captain H.',
              'More orders. No monsters.',
              'Your margins. Your control.',
            ].map((tag, i) => (
              <div key={i} className="comic-card" style={{ padding: '1rem 1.5rem', transform: `rotate(${i % 2 === 0 ? '-1' : '1'}deg)` }}>
                <span style={{ fontFamily: "'Bangers', cursive", fontSize: '1.25rem', color: i === 0 ? '#6A0DAD' : i === 1 ? '#FF3B30' : '#000', letterSpacing: '0.03em' }}>
                  "{tag}"
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="halftone-bg" style={{ padding: '5rem 1.5rem', background: '#6A0DAD', textAlign: 'center', position: 'relative' }}>
        <div className="container" style={{ maxWidth: '600px', position: 'relative', zIndex: 1 }}>
          <h2 className="heading-2" style={{ marginBottom: '1.5rem', color: '#FFD700' }}>Join the Fight</h2>
          <p style={{ color: 'rgba(255,255,255,0.85)', marginBottom: '2rem', fontWeight: 500, fontSize: '1.125rem' }}>
            Together, we defeat the beast and build a stronger future for every restaurant.
          </p>
          <Link to="/book-demo" className="btn-primary" style={{ fontSize: '1.125rem', padding: '16px 32px' }}>
            Book a Free Demo <ArrowRight size={20} style={{ marginLeft: '0.5rem' }} />
          </Link>
        </div>
      </section>
    </div>
  );
};
